import { ApiResult } from 'interfaces/APITypes';
import { ContentSet } from 'interfaces/StudioTypes';
import { Unit } from 'interfaces/Unit';

import { ServerSideFilter } from 'components/mytover/invite/UnitUserFilterSection';

import { contentInstance, makeRequest } from './client';

export const getUnit = async (id: string, params: any = null): Promise<ApiResult> => {
  return makeRequest(contentInstance.get(`/units/${id}`, { params: params }));
};

export const getSetsForUnit = async (id: string): Promise<ApiResult> => {
  return makeRequest(contentInstance.get(`/units/${id}/content-sets`));
};

export const syncSetsForUnit = async (id: string, sets: ContentSet[]): Promise<ApiResult> => {
  const payload = {
    packs: sets.map((s) => s.id),
  };
  return makeRequest(contentInstance.post(`/units/${id}/content-sets`, payload));
};

export const deleteSetFromUnit = async (set: ContentSet, unit: Unit): Promise<ApiResult> => {
  return makeRequest(contentInstance.delete(`/units/${unit.serial_number}/content-sets/${set.id}`));
};

export const getUnitActivity = async (id?: number | string, values?: ServerSideFilter): Promise<ApiResult> => {
  return makeRequest(contentInstance.get(`/units/${id}/activity`, { params: values }));
};
